import React from 'react';

const MusicWireTicker = () => {
  const headlines = [
  "SIGNALBLEED.NYC is now live in pre-launch mode",  
  "of Montreal @ Webster Hall — June 23 • Get tickets now!", 
  "Built for NYC artists, venues, and underground music discovery",
  "Submit your gig to get listed on our concert calendar",
  "Upload your music and reach NYC's underground scene",
  "Support local artists — activate your tip jar today",
];
  return (
    <div className="music-wire-ticker">
      <span className="wire-label">NYC MUSIC WIRE ⚡</span>
      <div className="wire-track">
        <div className="wire-content">
          {[...headlines, ...headlines].map((h, i) => (
            <span key={i}>
              <span className="wire-dot">•</span>
              {h}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MusicWireTicker;
